import { AppBar, Box, Button, Toolbar, Typography } from "@mui/material";
import colorConfigs from "../../configs/colorConfigs";
import sizeConfigs from "../../configs/sizeConfigs";
import AuthApi from "../../modules/auth";

const handleLogout = () => {
  const api = new AuthApi();
  api.logout();
}

const Topbar = () => {
  return (
    <AppBar
      position="fixed"
      sx={{
        width: `calc(100% - ${sizeConfigs.sidebar.width})`,
        ml: sizeConfigs.sidebar.width,
        boxShadow: "unset",
        backgroundColor: colorConfigs.topbar.bg,
        color: colorConfigs.topbar.color
      }}
    >
      <Toolbar>
        <Typography variant="h6">
          Landbook ADMIN
        </Typography>
        <Box sx={{ flexGrow: 1 }} />
        <Button onClick={handleLogout}>logout</Button>
      </Toolbar>
    </AppBar>
  );
};

export default Topbar;